<template>
    <sa-page-layout titolo="AnDIamo - Accessi Pianificati/Erogati" class="sa-no-space" btnRefreshVisible @refresh="onRefresh">
        <template slot="table-body">
            <AndiamoAccessiListComponent ref="cmpAndiamoAccessiListComponent" />
        </template>
    </sa-page-layout>
</template>

<script>
import SaPageLayout from "../../../template/sa/components/layout/contents/SaPageLayout.vue";
import AndiamoAccessiListComponent from "../components/AndiamoAccessiListComponent.vue";

export default {
    components: { SaPageLayout, AndiamoAccessiListComponent },
    methods: {
        onRefresh() {
            this.$refs.cmpAndiamoAccessiListComponent.loadData();
        },
    },
};
</script>

<style lang="scss" scoped></style>
